export const downloadUrls = {
  purchase: "/api_po/purchase_order/",
  shipment: "/api_shipment/consignment/",
  shipmentV1: "/api/shipment/v1/shipment/",
  asn: "/api_shipment/asn/",
  transfer: "/api_order/v2/tf_ord/",
  inventory: "/api_warehouse/stock/",
  inventoryDetail: "/api_warehouse/stock_line/",
  inventoryTransactions: "/api_report/transactions/",
  shipment_po: "/api_po/allocation/",
  shipment_to: "/api_order/allocation/",
  allocation_so: "/api/sale/v1/so_allocation/",
  allocation_mo: "/api/production/v1/mo_allocation/",
  receipt: "/api_po/receipt/",
  product: "/api_product/product/",
  productCategory: "/api_product/product_category/",
  productTag: "/api_product/product_tag/",
  productPlan: "/api_product/product_plan/",
  productAlias: "/api_product/product_alias/",
  pack: "/api_product/pack/",
  warehouse: "/api_supplier/warehouse/",
  supplier: "/api_supplier/supplier/",
  stockZone: "/api_warehouse/stock_zone/",
  stockLocation: "/api_warehouse/stock_location/",
  forecast: "/api_warehouse/forecast/",
  warehouseCosting: "/api_warehouse/warehouse_costing/",
  transactionReason: "/api_report/transaction_reason/",
  standardCost: "/api_warehouse/standard_costing/",
  chartsOfAccount: "/api_account/account/",
  paymentTerm: "/api_account/payment_term/",
  journalLine: "/api_account/journal_line/",
  taxRate: "/api_tax/tax_rate/",
  site: "/api/warehouse/v1/site/",
  workCenter: "/api/warehouse/v1/work_center/",
  people: "/api/production/v1/people/",
  users: "/api_user/v2/user/",
  bill: "/api_invoice/bill/",
  billChargeType: "/api_invoice/bill_charge_type/",
  saleInvoice: "/api/invoice/v1/sale_invoice/",
  receiptAdjustment: "/api_po/receipt_adjustment/",
  syncHistory: "/api_integration/sync_logs/",
  shopifyStores: "/integration/shopify/v1/store/",
  supplierCreditNote: "/api_invoice/supplier_credit_note/",
  customerCreditNote: "/api/invoice/v1/customer_credit_note/",
  prePayment: "/api_invoice/pre_payment/",
  customerTag: "/api/customer/v1/customer_tag/",
  stockReplenishment: "/api_warehouse/stock_replenishment/",
  plannedOrder: "/api_order/planned_order/",
  picklist: "/api/warehouse/v1/picklist/",
  customer: "/api/customer/v1/customer/",
  taxCategory: "/api/tax/v1/tax_category/",
  productTaxClassification: "/api/tax/v1/product_tax_classification/",
  customerSegment: "/api/customer/v1/customer_segment/",
  unitOfMeasure: "/api/uom/v1/unit_of_measure/",
  equipmentType: "/api/shipment/v1/equipment_type/",
  equipment: "/api/shipment/v1/equipment/",
  salesRep: "/api/user/v1/sales_rep/",
  pricelist: "/api/pricing/v1/pricelist/",
  promo: "/api/pricing/v1/promo/",
  quote: "/api/sale/v1/quotation/",
  salesOrder: "/api/sale/v1/order/",
  stockPack: "/api/warehouse/v1/stock_pack/",
  delivery: "/api/shipment/v1/delivery/",
  shipmentLeg: "/api/shipment/v1/shipment_leg/",
  customerReturn: "/api/sale/v1/return/",
  boms: "/api/production/v1/boms/",
  manufacturingOrder: "/api/production/v1/manufacturing_order/",
  coManufacturingOrder: "/api/production/v1/co_manufacturing_order/",
};

export const fileNameForDownload = {
  purchase: "purchases_",
  shipment: "shipments_",
  shipmentV1: "shipments_",
  asn: "asns_",
  transfer: "transfers_",
  inventory: "stock_summary_",
  inventoryDetail: "stock_details_",
  inventoryTransactions: "transactions_",
  shipment_po: "purchase_order_allocations_",
  shipment_to: "transfer_order_allocations_",
  allocation_so: "sales_order_allocations_",
  allocation_mo: "manufacturing_order_allocations_",
  receipt: "receipts_",
  product: "product_",
  productTag: "product_tag_",
  productPlan: "product_plan_",
  productAlias: "product_alias_",
  supplier: "supplier_",
  pack: "pack_",
  warehouse: "warehouse_",
  stockZone: "stock_zone_",
  stockLocation: "stock_location_",
  forecast: "forecast_",
  warehouseCosting: "warehouse_costing_",
  transactionReason: "transaction_reason_",
  standardCost: "standard_cost_",
  chartsOfAccount: "charts_account_",
  paymentTerm: "payment_term_",
  journalLine: "journal_line_",
  taxRate: "tax_rate",
  site: "site_",
  workCenter: "work_center_",
  people: "people_",
  users: "users_",
  boms: "boms_",
  bill: "bills_",
  billChargeType: "bill_charge_types_",
  saleInvoice: "sale_invoices_",
  receiptAdjustment: "receipt_adjustments_",
  syncHistory: "sync_history_",
  shopifyStores: "shopify_stores_",
  supplierCreditNote: "supplier_credit_notes_",
  customerCreditNote: "customer_credit_notes_",
  prePayment: "pre_payments_",
  customerTag: "customer_tags_",
  stockReplenishment: "stock_replenishments_",
  plannedOrder: "planned_orders_",
  customer: "customers_",
  picklist: "picklists_",
  taxCategory: "tax_categories_",
  productTaxClassification: "product_tax_classifications_",
  customerSegment: "customer_segments_",
  unitOfMeasure: "unit_of_measure_",
  equipmentType: "equipment_types_",
  equipment: "equipments_",
  salesRep: "sales_reps_",
  pricelist: "pricelists_",
  promo: "promos_",
  quote: "quotations_",
  salesOrder: "sales_orders_",
  stockPack: "stock_packs_",
  delivery: "deliveries_",
  shipmentLeg: "shipment_legs_",
  customerReturn: "customer_returns_",
  manufacturingOrder: "manufacturing_orders_",
  coManufacturingOrder: "co_manufacturing_orders_",
};
